import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/FacetCollectionConfigurations.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/private/v2/configurations/facets/collections`;
	}
	list(e) {
		return this.api.get(this.buildPath(n.baseUrl, e));
	}
	get(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}`));
	}
	create(e) {
		return this.api.post(n.baseUrl, e);
	}
	delete(e) {
		return this.api.delete(`${n.baseUrl}/${e}`);
	}
	update(e, t) {
		return this.api.put(`${n.baseUrl}/${e}`, t);
	}
};
export { n as FacetCollectionConfigurations };

//# sourceMappingURL=FacetCollectionConfigurations.js.map